import { FORM_SCENARIO_TYPE } from '~/utils/dictionaries';

export default {
	data() {
		return {
			isAwardedPointsFetchFailed: false,
			isAwardedPointsLoading: false,
			awardedPoints: 0,
		};
	},

	computed: {
		isBlockContainsLoyaltyEarnProduct() {
			return this.block.products.every((product) => product.is_earn_loyalty === 1)
				&& !this.isAwardedPointsFetchFailed;
		},

		isBlockContainsLoyaltyChargeProduct() {
			return this.block.products.every((product) => product.is_charge_loyalty === 1)
				&& !this.isAwardedPointsFetchFailed;
		},
	},

	methods: {
		getProductsWithActualPrice(products) {
			if (this.currentProduct?.id && this.finalPrice) {
				return products.map((product) => {
					if (product.id === this.currentProduct.id) {
						return { ...product, price: this.finalPrice };
					}
					return product;
				});
			}
			return products;
		},
		async fetchAwardedPoints() {
			this.awardedPoints = 0;
			let pointsSum = 0;

			if (!this.isBlockContainsLoyaltyEarnProduct && !this.isBlockContainsLoyaltyChargeProduct) {
				return;
			}

			if (this.$auth.user && this.$auth.user.loyalty_id && this.block.form_scenario_type === FORM_SCENARIO_TYPE.PAYMENT) {
				try {
					this.isAwardedPointsLoading = true;

					let products = this.selectedProducts?.length > 0
						? this.selectedProducts
						: this.allProductsFromGroup;

					products = this.getProductsWithActualPrice(products);

					let failedCount = 0;

					await Promise.all(products.map(async (product) => {
						const response = await this.$api.getTransactionInfoByProgram(
							product.id,
							product.price * (parseFloat(product.quantity ?? 1) || 0),
						).catch(() => {
							failedCount += 1;
						});

						if (response?.points) {
							pointsSum += parseFloat(response?.points);
						}
					}));

					if (products.length === failedCount) {
						this.isAwardedPointsFetchFailed = true;
					}
				} finally {
					this.isAwardedPointsLoading = false;
					this.awardedPoints = pointsSum;
				}
			}
		},
	},
};
